var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ActionModal,_vm._g(_vm._b({attrs:{"title":"Attention"},on:{"cancel":function($event){return _vm.$emit('close')}}},'action-modal',_vm.$attrs,false),_vm.$listeners),[_c('span',{attrs:{"role":"alert"}},[_vm._v("\n\t\t"+_vm._s(_setup.props.message)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }